export { HistoryPage as default } from '@/components/pages/Company/History'
